export default {
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "branches": {
            "add": "Add branch",
            "edit": "Edit branch",
            "delete": "Delete branch",
            "not_find": "Can not find branch with this code.",
            "id": "Id",
            "name": "Name",
            "warehouse_name": "The warehouse name already exists",
            "concept_code": "Code",
            "name_placeholder": "Enter the branch's name",
            "name_contpaq_placeholder": "Enter the contpaq branch's name",
            "concept_code_placeholder": "Enter the concept code",
            "status": "Status",
            "branch": "Branch",
            "branches": "Branches",
            "branch_placeholder": "Select the branch",
            "created_at": "Created at",
            "report_title": "Branches Report",
            "name_already_exists": "The name already exists",
            "concept_code_already_exists": "The concept code already exists",
            "branch_origin": "Origin",
            "branch_destination": "Destination"
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find customer with this code.",
            "id": "Id",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Customers Report",
            "code": "Code",
            "business_name": "Business Name",
            "rfc": "RFC",
            "with_company_logo": "With company logo",
            "logo_public": "Logo",
            "sync": "Sync Customers",
            "initialize_sync": "Start synchronization",
            "sync_text": "Product synchronization may take a while to be reflected"
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized.",
            "syncro": "The synchronizer is off",
            "contpaq": "Contpaq's error",
            "syncro_request_error": "The contpaq's synchronizer has problems",
            "syncro_request_empty": "The synchronizer has an empty response",
            "shipment_completed": "The shipment is already completed",
            "excel_without_products": "The excel hasn't products"
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the {model} {attribute}?",
            "delete_confirmation2": "Are you sure you want to delete {model} {attribute}?",
            "action_confirmation": "Are you sure you want to {action} this {model}?",
            "action_confirmation2": "Are you sure you want to {action} this {model}?",
            "import_modal": "Import {model} from CSV or Excel file"
        },
        "label_groups": {
            "add": "Add labelGroup",
            "edit": "Edit labelGroup",
            "delete": "Delete labelGroup",
            "not_find": "Can not find labelGroup with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the labelGroup's name",
            "status": "Status",
            "from_excel": "From Excel of Products",
            "from_order": "From Order",
            "from_shipment": "From Shipment",
            "created_at": "Created at",
            "report_title": "LabelGroups Report",
            "not_found": "Not found",
            "product_not_found": "Product not found",
            "from_transfer": "From Transfer"
        },
        "labels": {
            "add": "Add label",
            "edit": "Edit label",
            "delete": "Delete label",
            "not_find": "Can not find label with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the label's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Labels Report"
        },
        "locations": {
            "add": "Add location",
            "edit": "Edit location",
            "delete": "Delete location",
            "not_find": "Can not find location with this code.",
            "location_1_exists_error": "Location 1 does not exist",
            "location_2_exists_error": "Location 2 does not exist",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the location's name",
            "status": "Status",
            "branch_name": "Branch",
            "created_at": "Created at",
            "report_title": "Locations Report"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_user": "New User!",
            "add_new_user_message": "has added a new user"
        },
        "order_details": {
            "add": "Add orderDetail",
            "edit": "Edit orderDetail",
            "delete": "Delete orderDetail",
            "not_find": "Can not find orderDetail with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the orderDetail's name",
            "status": "Status",
            "description": "Description",
            "quantity_to_validate": "Cantidad a Validar",
            "quantity_validated": "Cantidad Validada",
            "details_completed": "Details Completed",
            "details_leftover": "Details Left Over",
            "details_missing": "Details Missing",
            "details_pending": "Details Pending",
            "warehouse_name": "Warehouse",
            "created_at": "Created at",
            "report_title": "OrderDetails Report"
        },
        "orders": {
            "add": "Add order",
            "edit": "Edit order",
            "delete": "Delete order",
            "not_find": "Can not find order with this code.",
            "pending_error": "The order is already pending",
            "complete_error": "The order is already complete",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the order's name",
            "status": "Status",
            "folio": "Folio of Order",
            "folio_placeholder": "Enter the folio of the order",
            "created_at": "Created at",
            "report_title": "Orders Report",
            "corrective_review": "Corrective review",
            "corrective_review_description": "Register issues detected after shipment or validation.",
            "order_context": "Order context",
            "preventive_summary": "Preventive review summary",
            "preventive_result": "Preventive result",
            "preventive_bypass": "Bypass",
            "preventive_none": "No preventive review",
            "preventive_in_review": "In review",
            "preventive_correct": "Correct",
            "preventive_incorrect": "Incorrect",
            "preventive_bypass_yes": "Yes",
            "preventive_bypass_no": "No",
            "preventive_bypass_na": "—",
            "preventive_status_warehouse_draft": "Draft",
            "preventive_status_warehouse_pending": "In review",
            "preventive_status_confirmed": "Confirmed",
            "preventive_reviewer": "Preventive reviewer",
            "preventive_comment": "Preventive comment",
            "preventive_missing": "This order has no preventive review; corrective review cannot be created.",
            "corrective_details_label": "Select affected order details",
            "corrective_form": "Corrective form",
            "corrective_comment": "Corrective comments",
            "corrective_resolved": "Corrective resolved",
            "corrective_submit": "Save corrective review",
            "corrective_created": "Corrective review saved successfully",
            "corrective_exists_title": "Corrective already exists",
            "corrective_exists_text": "This order already has a corrective review.",
            "corrective_invalid_title": "Corrective review cannot be created",
            "corrective_invalid_text": "Check submitted data and try again.",
            "corrective_select_details": "You must select at least one affected detail."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address.",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "planner": {
            "to_be_delivered": "To be delivered",
            "to_be_shipped_parcel": "To be shipped: Parcel",
            "to_be_shipped_deliveryman": "To be shipped: Deliveryman",
            "to_be_shipped_pick_up": "To be shipped: Pick up",
            "folio": "Folio",
            "all_branches": "All branches",
            "orders_updated": "Órders updated"
        },
        "products": {
            "add": "Add product",
            "edit": "Edit product",
            "delete": "Delete product",
            "not_find": "Can not find product with this code.",
            "not_found_title": "Product not found",
            "not_found_text": "No product was found with these codes",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the product's name",
            "code": "Code",
            "code_placeholder": "Enter the code",
            "location_1_display": "Location 1",
            "location_2_display": "Location 2",
            "location_1_placeholder": "Select the location 1",
            "location_2_placeholder": "Select the location 2",
            "code_1_placeholder": "Select the Initial Product",
            "code_2_placeholder": "Select the Final Product",
            "description": "Description",
            "description_placeholder": "Enter the description",
            "quantity": "Quantity",
            "status": "Status",
            "alternative_code": "Alternative Code",
            "units_measurement": "Measurement Units",
            "weight": "Weight",
            "packing": "Packing",
            "sync_product": "Sync Product",
            "sync_products": "Sync Products",
            "initialize_sync": "Initialize Sync",
            "sync_text": "The synchronization of products may take a while to be reflected",
            "created_at": "Created at",
            "report_title": "Products Report",
            "by_excel": "By Excel",
            "by_order": "By Folio of Order"
        },
        "purchase_order_balance_status": {
            "1": "Pending Balance",
            "2": "Without details",
            "3": "Completed Balance"
        },
        "purchase_order_details": {
            "add": "Add purchaseOrderDetail",
            "edit": "Edit purchaseOrderDetail",
            "delete": "Delete purchaseOrderDetail",
            "not_find": "Can not find purchaseOrderDetail with this code.",
            "discard_error": "Product discarded",
            "discard_product": "Discard product",
            "1": "Pending",
            "2": "Discarded",
            "3": "Closed",
            "discard": "Discarded",
            "id": "Id",
            "product_code_display": "Product Code",
            "product_id": "Product",
            "product_display": "Product",
            "product_placeholder": "Select the Product",
            "warehouse_display": "Warehouse",
            "warehouse_placeholder": "Select the Warehouse",
            "quantity": "CO",
            "active_shipment_quantity": "CE",
            "pending_amount_to_ship": "CPE",
            "pending_amount_to_be_received": "CPR",
            "quantity_placeholder": "Type the Quantity",
            "price": "Price",
            "price_placeholder": "Type the Price",
            "pending_quantity": "Pending Quantity",
            "received_quantity": "Received Quantity",
            "total": "Total",
            "subtotal": "Subtotal",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "PurchaseOrderDetails Report"
        },
        "purchase_orders": {
            "add": "Add Purchase Order",
            "edit": "Edit Purchase Order",
            "delete": "Delete Purchase Order",
            "not_find": "Can not find Purchase Order with this code.",
            "general_data": "General Data",
            "product_data": "Product Data",
            "added_products": "Added products",
            "add_with_excel": "Add Detail With Excel",
            "cancel_confirmation_title": "Cancel purchase order",
            "cancel_confirmation_text": "Are you sure you want to cancel this purchase order?",
            "has_active_shipment_error": "The order cant be cancelled or Disapproved, it has active shipments",
            "approve_error": "La orden de compra ya esta aprobada",
            "cancel_error": "La orden de compra ya esta cancelada",
            "pending_error": "La orden de compra ya esta des aprobada",
            "unique_manual_folio_error": "There is already a Purchase Order with this Folio",
            "1": "Completed",
            "2": "Pending",
            "3": "Cancelled",
            "4": "Aapproved",
            "approve": "Approved",
            "cancel": "Cancelled",
            "pending": "Disapproved",
            "approve_order": "Approve Order",
            "disapprove_order": "Disapprove Order",
            "id": "Id",
            "manual_folio": "Folio",
            "manual_folio_placeholder": "Enter the Folio",
            "folio": "Automatic Folio",
            "supplier_display": "Supplier",
            "supplier_placeholder": "Select the Supplier",
            "notes": "Notes",
            "total": "Total",
            "subtotal": "Subtotal",
            "currency_display": "Currency",
            "exchange_rate": "Exchange rate",
            "exchange_rate_placeholder": "Enter the Exchange rate",
            "status_id": "Status",
            "balance_status_id": "Balance",
            "created_at": "Created at",
            "report_title": "Purchase Order Report"
        },
        "reception_details": {
            "add": "Add receptionDetail",
            "edit": "Edit receptionDetail",
            "delete": "Delete receptionDetail",
            "not_find": "Can not find receptionDetail with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the receptionDetail's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "ReceptionDetails Report"
        },
        "receptions": {
            "add": "Add reception",
            "edit": "Edit reception",
            "delete": "Delete reception",
            "not_find": "Can not find reception with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the reception's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Receptions Report"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"/login\"> Terms of use </a> and our <a href=\"/login\"> Privacy policy </a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "reset": {
            "subject": "Reset your HMM Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in {count} minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "shipment_details": {
            "add": "Add shipment Detail",
            "edit": "Edit shipment Detail",
            "delete": "Delete shipment Detail",
            "not_find": "Can not find shipment Detail with this code.",
            "id": "Id",
            "purchase_order_folio_display": "Purchase Order",
            "shipment_display": "Shpment Number",
            "product_display": "Product Name",
            "product_description_display": "Product Description",
            "product_code_display": "Product Code",
            "quantity": "Quantity",
            "quantity_to_validate": "Quantity to Validate",
            "quantity_validated": "Quantity Validated",
            "details_completed": "Details Completed",
            "details_leftover": "Details Left Over",
            "details_missing": "Details Missing",
            "details_pending": "Details Pending",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Shipment Details Report"
        },
        "shipments": {
            "add": "Add shipment",
            "edit": "Edit shipment",
            "delete": "Delete shipment",
            "not_find": "Can not find shipment with this code.",
            "not_found_title": "Order not found",
            "not_found_text": "No order was found with these codes",
            "cancel_confirmation_title": "Cancel Shipment",
            "cancel_confirmation_text": "Are you sure you want to cancel this shipment?",
            "cancel_error": "Shipment already cancelled or not valid for cancellation",
            "add_tracking_guide": "Add tracking guide",
            "add_file": "Add file",
            "description_attached": "Drag or import files",
            "select_file": "Select file",
            "1": "Pending",
            "2": "Completed",
            "3": "Partial",
            "4": "Received",
            "5": "Cancelled",
            "cancel": "Cancelled",
            "complete": "Completed",
            "id": "Id",
            "supplier_display": "Supplier",
            "folio": "Folio",
            "shipment_date": "Shipment Date",
            "lead_time": "Lead Time",
            "lead_time_placeholder": "Enter the Lead Time",
            "arrival_date": "ETA",
            "notes": "Reference",
            "notes_placeholder": "Enter the Reference",
            "status_id": "Status",
            "complete_title": "Complete Shipment",
            "completed_comment": "Comment",
            "completed_comment_placeholder": "Enter the Comment",
            "created_at": "Created at",
            "report_title": "Shipments Report"
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Purchase Order",
            "purchase_orders": "Purchase Orders",
            "purchase_order_detail": "Purchase Order Detail",
            "purchase_order_details": "Purchase Order Details",
            "shipment": "Shipment",
            "shipments": "Shipments",
            "shipment_detail": "Shipment Detail",
            "shipment_details": "Shipment Details",
            "supplier": "Supplier",
            "suppliers": "Suppliers",
            "tracking_guide": "Tracking Guide",
            "tracking_guides": "Tracking Guides",
            "tracking_guide_file": "File",
            "tracking_guide_files": "Files",
            "branches": "Branches",
            "branch": "Branch",
            "privacidad": "privacidad",
            "description": "An Overview of your {attribute}",
            "search": "Search {attribute} by{columns} or {column}",
            "search_by_column": "Search {attribute} by {column}",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "import": "Import",
            "export": "Export",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "please_wait": "Please Wait...",
            "download": "Download",
            "cancelled": "Cancelled",
            "disapprove": "Disapprove",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "complete": "Complete",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "will_refresh_at_finish": "Will refresh the page at finish",
            "pending_jobs": "Pending Jobs",
            "wait_til_finish_jobs": "Waiting for jobs to finish",
            "transfers": "Transfers",
            "transfer": "Trasnfer",
            "transfer_detail": "Transfer detail",
            "transfer_details": "transfer details",
            "select_transfers": "Select the transfers",
            "planner": "Planner"
        },
        "suppliers": {
            "add": "Add supplier",
            "edit": "Edit supplier",
            "delete": "Delete supplier",
            "not_find": "Can not find supplier with this code.",
            "initialize_sync": "Initialize Sync",
            "sync_text": "The synchronization of suppliers may take a while to be reflected",
            "sync": "Sync Suppliers",
            "id": "Id",
            "code": "Code",
            "business_name": "Business Name",
            "rfc": "RFC",
            "cfdi_use": "CFDI Use",
            "fiscal_regime": "Fiscal Regime",
            "name_placeholder": "Enter the supplier's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "Suppliers Report"
        },
        "tracking_guide_files": {
            "add": "Add trackingGuideFile",
            "edit": "Edit trackingGuideFile",
            "delete": "Delete trackingGuideFile",
            "not_find": "Can not find trackingGuideFile with this code.",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the trackingGuideFile's name",
            "status": "Status",
            "created_at": "Created at",
            "report_title": "TrackingGuideFiles Report"
        },
        "tracking_guides": {
            "add": "Add trackingGuide",
            "edit": "Edit trackingGuide",
            "delete": "Delete trackingGuide",
            "not_find": "Could not find any Tracking Guide with this code.",
            "id": "Id",
            "notes": "Notes",
            "notes_placeholder": "Enter the notes",
            "user_display": "User",
            "status": "Status",
            "files": "Files",
            "created_at": "Created at",
            "report_title": "TrackingGuides Report"
        },
        "transfer_details": {
            "product_code": "Code",
            "product_name": "Product",
            "quantity_transfer": "Transfer",
            "quantity_shipment": "Shipment",
            "quantity_received": "Received",
            "quantity_difference": "Difference",
            "status_reception_product_id": "Status",
            "missing": "Missing",
            "correct": "Correct",
            "excess": "Excess",
            "comments": "Comments"
        },
        "transfers": {
            "add": "Add",
            "folio": "Folio",
            "origin": "Origin",
            "destination": "Destination",
            "status_transfer": "Status",
            "status_reception": "Reception status",
            "in_progress": "In progress",
            "shipment": "Shipment",
            "scanned": "Scanned",
            "canceled": "Cancelado",
            "pending": "Pending",
            "complete": "Complete",
            "approved": "Approved",
            "approve": "Approve",
            "comments": "Comments",
            "comment": "Comment",
            "comments_placeholder": "(Optional)",
            "shipment_comments": "Shipment comments",
            "reception_comments": "Reception comments",
            "in_complete": "Incomplete",
            "created_at": "Created at",
            "send_to_shipment": "Shipment",
            "add_products_with_excel": "Add products with excel",
            "print_tags": "Print tags",
            "add_with_excel": "Add products with excel",
            "scanned_subject": "Scan",
            "shipment_subject": "Shipment",
            "sent_by": "Sent by: "
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "created_at": "Created at",
            "report_title": "Users Report",
            "has_branch": "Has Branch"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal to {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "string": "The {attribute} must be less than or equal to {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address"
        },
        "warehouses": {
            "add": "Add warehouse",
            "edit": "Edit warehouse",
            "delete": "Delete warehouse",
            "not_find": "Can not find warehouse with this code.",
            "initialize_sync": "Initialize Sync",
            "sync_text": "The synchronization of warehouses may take a while to be reflected",
            "sync": "Sync Warehouses",
            "created_at": "Created at",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the warehouse's name",
            "report_title": "Warehouses Report",
            "status": "Status"
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    },
    "es": {
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en {seconds} segundos."
        },
        "branches": {
            "add": "Agregar Sucursal",
            "edit": "Editar Sucuarsal",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar una Sucursal con este código.",
            "id": "Id",
            "name": "Nombre",
            "warehouse_name": "Nombre del contpaq",
            "concept_code": "Código de concepto",
            "name_placeholder": "Ingresa el nombre de la sucursal",
            "name_contpaq_placeholder": "Ingresa el nombre en contpaq",
            "concept_code_placeholder": "Ingresa el código de concepto de la sucursal",
            "status": "Estatus",
            "branch": "Sucursal",
            "branches": "Sucursales",
            "branch_placeholder": "Selecciona la sucursal",
            "created_at": "Creado en",
            "report_title": "Reporte de Sucursales",
            "name_already_exists": "El nombre de la sucursal ya existe",
            "concept_code_already_exists": "El código de concepto de la sucursal ya existe",
            "warehouse_name_already_exists": "El nombre de almacen ya existe",
            "branch_origin": "Origen",
            "branch_destination": "Destino"
        },
        "customers": {
            "edit": "Editar Cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "id": "Id",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Customers",
            "code": "Codigo",
            "business_name": "Razon Social",
            "rfc": "RFC",
            "with_company_logo": "Logo de empresa",
            "logo_public": "Logo",
            "sync": "Sincronizar Clientes",
            "initialize_sync": "Iniciar sincronizacion",
            "sync_text": "La sincronizacion de clientes puede tardar un tiempo en verse reflejada"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "No autorizado.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción",
            "reception_completed": "Ya esta completa esta recepcion",
            "order_completed": "Ya esta completa esta recepcion",
            "validated": "Ya se encuentra validado este detalle",
            "overflow": "La cantidad ingresada es mayor al restante",
            "syncro": "El sincronizador esta apagado",
            "contpaq": "Error de Contpaq",
            "syncro_request_error": "El sincronizador de contpaq presenta problemas",
            "syncro_request_empty": "El sincronizador retorna una respuesta vacia",
            "shipment_completed": "El envío ya esta completo",
            "title_same_branch": "Error sucursal",
            "selected_same_branch": "No se puede traspasar a la misma sucursal",
            "title_without_products": "Sin productos",
            "without_products": "Este registro no tiene productos",
            "excel_without_products": "El excel no tiene productos",
            "error_status": "Error {attribute}",
            "server_error": "Error de servidor",
            "invalid_data": "Datos inválidos",
            "invalid_value": "Valor inválido {attribute}",
            "file_not_found": "Archivo no encontrado"
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas {action} esta {model}?",
            "action_confirmation2": "¿Seguro que deseas {action} este {model}?",
            "import_modal": "Importar {model} desde un archivo CSV o Excel"
        },
        "label_groups": {
            "add": "Agregar labelGroup",
            "edit": "Editar labelGroup",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un labelGroup con este código.",
            "id": "Id",
            "name": "Nombre de producto",
            "product_display": "Nombre de producto",
            "name_placeholder": "Ingresa el nombre de producto",
            "code": "Codigo",
            "product_code_display": "Codigo",
            "code_placeholder": "Ingresa el codigo de etiqueta",
            "description": "Descripcion",
            "description_placeholder": "Ingresa la descripcion de etiqueta",
            "quantity": "Cantidad de etiquetas",
            "quantity_placeholder": "Ingresa la cantidad de etiquetas",
            "products_by_label": "Productos por etiqueta",
            "status": "Estatus",
            "from_order": "Desde Pedido",
            "from_shipment": "Desde Embarque",
            "from_excel": "Desde Excel",
            "print": "Imprimir",
            "created_at": "Creado en",
            "report_title": "Reporte de LabelGroups",
            "not_found": "No encontrado",
            "product_not_found": "Producto no encontrado",
            "from_transfer": "Desde Traspaso"
        },
        "labels": {
            "add": "Agregar label",
            "edit": "Editar label",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un label con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del label",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Labels"
        },
        "locations": {
            "add": "Agregar ubicación",
            "edit": "Editar ubicación",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un ubicación con este código.",
            "location_1_exists_error": "Locación 1 no existe",
            "location_2_exists_error": "Locación 2 no existe",
            "id": "Id",
            "code": "Codigo",
            "code_placeholder": "Ingresa el codigo del ubicación",
            "status": "Estatus",
            "branch_name": "Sucursal",
            "created_at": "Creado en",
            "report_title": "Reporte de Locations"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_user": "Usuario Nuevo!",
            "add_new_user_message": "agrego un nuevo usuario",
            "reception_completed": "Se completo el embarque",
            "order_completed": "Se completo la orden"
        },
        "order_details": {
            "add": "Agregar orderDetail",
            "edit": "Editar orderDetail",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un orderDetail con este código.",
            "quantity": "Cantidad",
            "units_measurement": "Unidad de medida",
            "name": "Nombre",
            "product_id": "Product",
            "order_id": "Order",
            "code": "Codigo",
            "description": "Descripción",
            "details_completed": "Partidas completas",
            "details_leftover": "Partidas con sobrantes",
            "details_missing": "Partidas con faltantes",
            "details_pending": "Partidas con pendientes",
            "warehouse_name": "Almacén",
            "created_at": "Creado en",
            "report_title": "Reporte de OrderDetails"
        },
        "orders": {
            "add": "Agregar order",
            "edit": "Editar order",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un order con este código.",
            "pending_error": "La orden ya esta pendiente.",
            "complete_error": "La orden ya esta completa.",
            "concept_code": "Concepto Codigo",
            "first_sync": "Fecha primer sincronizacion",
            "internal_number": "# orden interno",
            "serie": "Serie",
            "folio": "Folio de pedido",
            "customer_supplier_code": "Código cliente",
            "social_reason": "Razón social",
            "customer_supplier_invoice_folio": "Folio factura cliente",
            "declaration": "Pedimento (alta)",
            "status": "Estatus",
            "folio_placeholder": "Ingrese el folio del pedido",
            "created_at": "Creado en",
            "report_title": "Reporte de Orders",
            "corrective_review": "Revisión correctiva",
            "corrective_review_description": "Registra incidencias detectadas después del envío o validación.",
            "order_context": "Contexto de la orden",
            "preventive_summary": "Resumen de revisión preventiva",
            "preventive_result": "Resultado preventiva",
            "preventive_bypass": "Bypass",
            "preventive_none": "Sin preventivo",
            "preventive_in_review": "En revisión",
            "preventive_correct": "Correcto",
            "preventive_incorrect": "Incorrecto",
            "preventive_bypass_yes": "Sí",
            "preventive_bypass_no": "No",
            "preventive_bypass_na": "—",
            "preventive_status_warehouse_draft": "Borrador",
            "preventive_status_warehouse_pending": "En revisión",
            "preventive_status_confirmed": "Confirmada",
            "preventive_reviewer": "Usuario que revisó preventivo",
            "preventive_comment": "Comentario preventiva",
            "preventive_missing": "Esta orden no cuenta con revisión preventiva, no es posible levantar correctivo.",
            "corrective_details_label": "Selecciona los detalles con incidencia",
            "corrective_form": "Formulario de correctivo",
            "corrective_comment": "Comentarios del correctivo",
            "corrective_resolved": "Correctivo resuelto",
            "corrective_submit": "Guardar correctivo",
            "corrective_created": "Revisión correctiva guardada correctamente",
            "corrective_exists_title": "Correctivo existente",
            "corrective_exists_text": "Esta orden ya tiene revisión correctiva registrada.",
            "corrective_invalid_title": "No fue posible registrar el correctivo",
            "corrective_invalid_text": "Verifica la información enviada e intenta de nuevo.",
            "corrective_select_details": "Debes seleccionar al menos un detalle con incidencia."
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "planner": {
            "to_be_delivered": "Por surtir",
            "to_be_shipped_parcel": "Por enviar: Paqueteria",
            "to_be_shipped_deliveryman": "Por enviar: Repartidor",
            "to_be_shipped_pick_up": "Por enviar: Recogen en sucursal",
            "folio": "Folio",
            "all_branches": "Todas las sucursales",
            "orders_updated": "Órdenes actualizadas"
        },
        "products": {
            "add": "Agregar product",
            "edit": "Editar product",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un product con este código.",
            "not_found_title": "Producto no encontrado",
            "not_found_text": "No se encontró un producto con estos códigos",
            "change_location": "Cambiar ubicación",
            "by_excel": "Por Excel",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre de producto",
            "code": "Codigo",
            "code_placeholder": "Ingresa el codigo de producto",
            "location_1_display": "Codigo de ubicación 1",
            "location_2_display": "Codigo de ubicación 2",
            "location_1_placeholder": "Selecciona el codigo de ubicación 1 de producto",
            "location_2_placeholder": "Selecciona el codigo de ubicación 2 de producto",
            "grouper_placeholder": "Seleccione el Agrupador",
            "family_placeholder": "Seleccione la Familia",
            "code_1_placeholder": "Seleccione el Producto Inicial",
            "code_2_placeholder": "Seleccione el Producto Final",
            "description": "Descripcion",
            "description_placeholder": "Ingresa la descripcion de producto",
            "quantity": "Cantidad",
            "status": "Estatus",
            "alternative_code": "Codigo alterno",
            "units_measurement": "Unidad de medida",
            "weight": "Peso",
            "packing": "Empaque",
            "sync_product": "Sincronizar producto",
            "sync_products": "Sincronizar productos",
            "initialize_sync": "Iniciar sincronizacion",
            "sync_text": "La sincronizacion de productos puede tardar un tiempo en verse reflejada",
            "branch_display": "Sucursal",
            "created_at": "Creado en",
            "report_title": "Reporte de Productos",
            "by_order": "Por Folio de Pedido"
        },
        "purchase_order_balance_status": {
            "1": "Saldo pendiente",
            "2": "Sin detalles",
            "3": "Saldo completado"
        },
        "purchase_order_details": {
            "add": "Agregar purchaseOrderDetail",
            "edit": "Editar purchaseOrderDetail",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un purchaseOrderDetail con este código.",
            "discard_error": "Producto ya descartado",
            "discard_product": "Descartar producto",
            "1": "Pendiente",
            "2": "Descartado",
            "3": "Cerrado",
            "discard": "Descartado",
            "id": "Id",
            "product_code_display": "Codigo del Producto",
            "product_id": "Producto",
            "product_display": "Producto",
            "product_placeholder": "Seleccione el Producto",
            "warehouse_display": "Almacen",
            "warehouse_placeholder": "Seleccione el Almacen",
            "quantity": "CO",
            "active_shipment_quantity": "CE",
            "pending_amount_to_ship": "CPE",
            "pending_amount_to_be_received": "CPR",
            "quantity_placeholder": "Ingrese la Cantidad",
            "price": "Precio",
            "price_placeholder": "Ingrese el Precio",
            "pending_quantity": "Cantidad Pendiente",
            "received_quantity": "Cantidad Recibida",
            "total": "Total",
            "subtotal": "Subtotal",
            "status_id": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de PurchaseOrderDetails",
            "purchase_order_manual_folio": "Folio Manual",
            "purchase_order_folio": "Folio",
            "purchase_order_created_at": "Creado en"
        },
        "purchase_orders": {
            "add": "Agregar Orden de Compra",
            "edit": "Editar Orden de Compra",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar una Orden de Compra con este código.",
            "general_data": "Datos Generales",
            "product_data": "Datos del Producto",
            "added_products": "Productos Generales",
            "add_with_excel": "Agregar productos con Excel",
            "cancel_confirmation_title": "Cancelar Orden de Compra",
            "cancel_confirmation_text": "¿Está seguro que quiere cancelar esta Orden?",
            "has_active_shipment_error": "La orden no puede ser cancelada o Des Aprobada porque tiene embarques activos",
            "approve_error": "Purchase order is already approved",
            "cancel_error": "Purchase order is already canceled",
            "pending_error": "Purchase order is alreade pending",
            "unique_manual_folio_error": "Ya existe una Orden de compra con este Folio",
            "1": "Completado",
            "2": "Pendiente",
            "3": "Cancelado",
            "4": "Aprobado",
            "approve": "Aprobada",
            "cancel": "Cancelada",
            "pending": "Des Aprobada",
            "approve_order": "Aprobar Orden",
            "disapprove_order": "Des Aprobar Orden",
            "id": "Id",
            "manual_folio": "Folio",
            "folio": "Folio Automático",
            "manual_folio_placeholder": "Ingrese el Folio",
            "supplier_display": "Proveedor",
            "supplier_placeholder": "Seleccione al Proveedor",
            "notes": "Notas",
            "total": "Total",
            "subtotal": "Subtotal",
            "currency_display": "Moneda",
            "exchange_rate": "Tipo de Cambio",
            "exchange_rate_placeholder": "Ingresa el tipo de cambio",
            "status_id": "Estatus",
            "balance_status_id": "Saldo",
            "branch_display": "Sucursal",
            "created_at": "Creado en",
            "report_title": "Reporte de Ordenes de Compra"
        },
        "reception_details": {
            "add": "Agregar receptionDetail",
            "edit": "Editar receptionDetail",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un receptionDetail con este código.",
            "id": "Id",
            "code": "Codigo de producto",
            "quantity": "Cantidad",
            "name": "Nombre",
            "description": "Descripcion",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de ReceptionDetails"
        },
        "receptions": {
            "add": "Agregar order",
            "edit": "Editar order",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un order con este código.",
            "internal_number": "# recepcion interno",
            "serie": "Serie",
            "folio": "Folio",
            "customer_supplier_code": "Código proveedor",
            "social_reason": "Razón social",
            "customer_supplier_invoice_folio": "Folio factura proveedor",
            "declaration": "Pedimento (alta)",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Orders"
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"/login\" class=\"content-vertical text-secondary\"> Términos de uso</a> y nuestra <a href=\"/login\"> Política de privacidad</a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "reset": {
            "subject": "Restablece tu contraseña de HMM",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en {count} minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "shipment_details": {
            "add": "Agregar detalle de Embarque",
            "edit": "Editar detalle de Embarque",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un detalle de Embarque con este código.",
            "id": "Id",
            "purchase_order_folio_display": "Orden de Compra",
            "shipment_display": "Numero de Embarque",
            "product_display": "Nombre del Producto",
            "product_description_display": "Descripción del Producto",
            "product_code_display": "Codigo del Producto",
            "quantity": "Cantidad",
            "quantity_to_validate": "Cantidad a Validar",
            "quantity_validated": "Cantidad Validada",
            "details_completed": "Partidas completas",
            "details_leftover": "Partidas con sobrantes",
            "details_missing": "Partidas con faltantes",
            "details_pending": "Partidas con pendientes",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de detalle de Embarques",
            "shipment_status_id": "Estatus Embarque",
            "shipment_arrival_date": "ETA",
            "shipment_created_at": "Creado en",
            "shipment_folio": "Folio Embarque"
        },
        "shipments": {
            "add": "Crear embarque",
            "edit": "Editar embarque",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un embarque con este código.",
            "not_found_title": "Detalle de orden no encontrado",
            "not_found_text": "No se encontró un detalle de orden con estos códigos",
            "cancel_confirmation_title": "Cancelar Embarque",
            "cancel_confirmation_text": "Esta seguro que quiere cancelar este Embarque?",
            "cancel_error": "Embarque ya cancelado o con status no valido para cancelación",
            "add_tracking_guide": "Agregar guía de embarque",
            "add_file": "Agregar archivo",
            "description_attached": "Arrastra o importa archivos",
            "select_file": "Seleccionar Archivo",
            "1": "Pendiente",
            "2": "Completado",
            "3": "Parcial",
            "4": "Recibido",
            "5": "Cancelado",
            "cancel": "Cancelado",
            "complete": "Completado",
            "id": "Id",
            "supplier_display": "Proveedor",
            "folio": "Folio",
            "shipment_date": "Fecha de Embarque",
            "lead_time": "Lead Time",
            "lead_time_placeholder": "Ingrese el Lead Time",
            "arrival_date": "ETA",
            "notes": "Referencia",
            "notes_placeholder": "Ingrese la Referencia",
            "status_id": "Estatus",
            "complete_title": "Completar Embarque",
            "completed_comment": "Comentario",
            "completed_comment_placeholder": "Ingrese el Comentario",
            "branch_display": "Sucursal",
            "created_at": "Creado en",
            "report_title": "Reporte de Embarques"
        },
        "strings": {
            "dashboard": "Inicio",
            "overview": "Inicio",
            "users": "Usuarios",
            "user": "Usuario",
            "customer": "Cliente",
            "customers": "Clientes",
            "product": "Producto",
            "products": "Productos",
            "label_group": "Grupo de etiquetas",
            "label_groups": "Grupos de etiquetas",
            "label_generator": "Generador de etiquetas",
            "label": "Etiqueta",
            "labels": "Etiquetas",
            "order": "Orden",
            "orders": "Ordenes",
            "purchase_order": "Orden de Compra",
            "purchase_orders": "Ordenes de Compra",
            "purchase_order_detail": "Detalle de Orden de Compra",
            "purchase_order_details": "Detalles de Orden de Compra",
            "reception": "Recepcion",
            "receptions": "Recepciones",
            "supplier": "Proveedor",
            "suppliers": "Proveedores",
            "location": "Ubicación",
            "locations": "Ubicaciones",
            "shipment": "Embarque",
            "shipments": "Embarques",
            "shipment_detail": "Detalle de Embarque",
            "shipment_details": "Detalles de Embarque",
            "tracking_guide": "Guía de Embarque",
            "tracking_guides": "Guías de Embarque",
            "tracking_guide_file": "Archivo: ",
            "tracking_guide_files": "Archivos de Guías de Embarque",
            "branches": "Sucursales",
            "branch": "Sucursal",
            "warehouse": "Almacen",
            "warehouses": "Almacenes",
            "privacidad": "privacidad",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar {attribute} por{columns} ó {column}",
            "search_by_column": "Buscar {attribute} por {column}",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "export": "Exportar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Marcar todo como leído",
            "exit": "Salir",
            "feedback": "Enviar Comentarios",
            "give_feedback": "Dar opinión",
            "shortcuts": "Atajos de teclado",
            "close_modal": "Cerrar modal",
            "create": "Crear registro",
            "view_selected": "Ver seleccionado",
            "edit_selected": "Editar seleccionado",
            "view_notifications": "Ver notificaciones",
            "find": "Buscar un registro",
            "register": "Registro",
            "label_generator_description": "Ingresa el código o descripción del producto, o bien imprime desde pedido",
            "please_wait": "Por favor espere...",
            "download": "Descargar",
            "syncro": "Sincronizar",
            "cancelled": "Cancelado",
            "disapprove": "Desaprobar",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "complete": "Completar",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_paid": "Pagar",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "select_products": "Selecciona los productos",
            "select_orders": "Selecciona las ordenes",
            "sync_successfully": "Sincronizacion satisfactoria",
            "sync_unsuccessfully": "Sincronizacion fallida",
            "sync_time_out": "Tiempo de espera agotado",
            "sync_unknown": "Error desconocido",
            "sync_error_calling_Contpaq_API": "Error al llamar la API de Contpaq",
            "add_location": "Agregar ubicación",
            "export_without_location": "Productos sin ubicación",
            "not_find": "No se puede encontrar un detalle con este código.",
            "will_refresh_at_finish": "La pagina se recargara automaticamente al finalizar",
            "pending_jobs": "Tareas pendientes",
            "wait_til_finish_jobs": "Espere a que se finalizen las tareas pendientes",
            "transfer": "Traspaso",
            "transfers": "Traspasos",
            "send_to_shipment": "Embarcar",
            "transfer_detail": "Detalle de taspaso",
            "transfer_details": "detalles de taspaso",
            "select_transfers": "Selecciona el traspaso",
            "planner": "Planner"
        },
        "suppliers": {
            "add": "Agregar supplier",
            "edit": "Editar supplier",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un supplier con este código.",
            "initialize_sync": "Iniciar sincronizacion",
            "sync_text": "La sincronizacion de proveedores puede tardar un tiempo en verse reflejada",
            "sync": "Sincronizar Proveedores",
            "id": "Id",
            "code": "Codigo",
            "business_name": "Razón Social",
            "rfc": "RFC",
            "cfdi_use": "Uso de CFDI",
            "fiscal_regime": "Regimen Fiscal",
            "name_placeholder": "Ingresa el nombre del supplier",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de Suppliers"
        },
        "tracking_guide_files": {
            "add": "Agregar trackingGuideFile",
            "edit": "Editar trackingGuideFile",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un trackingGuideFile con este código.",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del trackingGuideFile",
            "status": "Estatus",
            "created_at": "Creado en",
            "report_title": "Reporte de TrackingGuideFiles"
        },
        "tracking_guides": {
            "add": "Agregar guía de embarque",
            "edit": "Editar guía de embarque",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar una guía de embarque con este código.",
            "id": "Id",
            "notes": "Notas",
            "notes_placeholder": "Ingrese las Notas",
            "user_display": "Usuario",
            "status": "Estatus",
            "files": "Archivos",
            "created_at": "Creado en",
            "report_title": "Reporte de Guías de embarque"
        },
        "transfer_details": {
            "product_code": "Código",
            "product_name": "Producto",
            "quantity_transfer": "Planeado",
            "quantity_shipment": "Embarcado",
            "quantity_received": "Recibido",
            "quantity_difference": "Diferencia",
            "status_reception_product_id": "Estatus",
            "missing": "Pendiente",
            "correct": "Correcto",
            "excess": "Excedente",
            "comments": "Comentarios"
        },
        "transfers": {
            "add": "Agregar",
            "folio": "Folio",
            "origin": "Origen",
            "destination": "Destino",
            "status_transfer": "Estatus",
            "status_reception": "Estatus de recepción",
            "in_progress": "En progreso",
            "shipment": "Embarcado",
            "scanned": "Escaneado",
            "canceled": "Cancelado",
            "pending": "Pendiente",
            "complete": "Completo",
            "approved": "Aprobado",
            "approve": "Aprobar",
            "comments": "Referencia",
            "comment": "Comentario",
            "comments_placeholder": "(Opcional)",
            "shipment_comments": "Comentarios de embarque",
            "reception_comments": "Comentarios de recepción",
            "in_complete": "Incompleto",
            "created_at": "Creado el",
            "send_to_shipment": "Embarcar",
            "add_products_with_excel": "Agregar productos",
            "print_tags": "Imprimir etiquetas",
            "add_with_excel": "Agregar productos con excel",
            "scanned_subject": "Escaneo",
            "shipment_subject": "Embarque",
            "sent_by": "Enviado por: "
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios",
            "has_branch": "Asignar una sucursal"
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha después a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser una matriz.",
            "before": "El campo {attribute} debe ser una fecha antes de {date}.",
            "before_or_equal": "El campo {attribute} debe ser una fecha antes o igual a {date}.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "El {attribute} la confirmación no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El seleccionado {attribute} no es válido.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que {value}.",
                "file": "El {attribute} debe ser mayor que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor que {value} caracteres.",
                "array": "El {attribute} debe tener más que {value} artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que {value}.",
                "file": "El {attribute} debe ser mayor o igual que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que {value} caracteres.",
                "array": "El {attribute} debe tener {value} artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que {value}.",
                "file": "El {attribute} debe ser menor que {value} kilobytes.",
                "string": "El {attribute} debe ser menor que {value} caracteres.",
                "array": "El {attribute} debe tener menos que {value} artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual {value}.",
                "file": "El {attribute} debe ser menor o igual {value} kilobytes.",
                "string": "El {attribute} debe ser menor o igual {value} caracteres.",
                "array": "El {attribute} no debe tener más de {value} artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos."
            },
            "mimes": "El {attribute} must be a file of type: {values}.",
            "mimetypes": "Los {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos de {min}.",
                "file": "El campo {attribute} debe ser al menos de {min} kilobytes.",
                "string": "El campo {attribute} debe ser al menos de {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El campo {attribute} tiene que ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El campo {attribute} formato no es válido.",
            "required": "El campo {attribute} es requerido.",
            "required_if": "El campo {attribute} es requerido cuando {other} es {value}.",
            "required_unless": "El campo {attribute} es requerido a menos que {other} es en {values}.",
            "required_with": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_with_all": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_without": "El campo {attribute} es requerido cuando {values} no esta presente.",
            "required_without_all": "El campo {attribute} es requerido cuando ninguno de {values} estan presentes.",
            "same": "El campo {attribute} debe coincidir con {other}.",
            "size": {
                "numeric": "El {attribute} debe ser {size}.",
                "file": "El {attribute} debe ser {size} kilobytes.",
                "string": "El {attribute} debe ser {size} caracteres.",
                "array": "El {attribute} debe contener {size} artículos."
            },
            "string": "El {attribute} debe ser un texto.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "quantity_incorrect": "Cantidad incorrecta",
            "products_by_label_incorrect": "Productos por etiqueta incorrecto",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico"
        },
        "warehouses": {
            "add": "Agregar warehouse",
            "edit": "Editar warehouse",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un almacen con este codigo",
            "initialize_sync": "Iniciar sincronizacion",
            "sync_text": "La sincronizacion de almacenes puede tardar un tiempo en verse reflejada",
            "sync": "Sincronizar Almacenes",
            "warehouse": "Almacen",
            "warehouses": "Almancenes",
            "warehouse_placeholder": "Selecciona almancen(es)",
            "created_at": "Creado en",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del warehouse",
            "report_title": "Reporte de Warehouses",
            "status": "Estatus"
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    }
}
